import {
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import { schema } from '@snap-types/schemas';
import { z } from 'zod/v4';

const d = schema.t.dec;

export const columns = {
  uuid,
  sortOrder: z.number().int().default(0),
  margin: schema.t.dec.fromDecimalLike,
  adjustment: schema.t.dec.fromDecimalLike,
  priceSegmentConfigUuid: uuid,

  ...nullableCreatedByUserUuid,
  ...timestamps,

  deletedAt: z.date().nullish(),
};

export const columnValidators = {
  sortOrder: z.number().int().default(0),
  margin: d.fromUnknown.check(d.checks.gte(0)),
  adjustment: d.fromUnknown.check(d.checks.gte(0)),
};
